export enum CompanyDocumentVisibility {
  ADMINS_ONLY = 'ADMINS_ONLY',
  SPECIFIC_USERS = 'SPECIFIC_USERS',
  ALL_USERS = 'ALL_USERS',
}
